/* eslint-disable no-unused-expressions */
import React, { Component, useState, useEffect } from "react";
import QrReader from "react-qr-reader";
import { Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { MdClose } from "react-icons/md";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ScannerError from "./ScannerError"

const qr = "/qr.svg";
const Informacion = "/help-round-button.svg";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
// import QrReader from 'react-qr-scanner'
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <MdClose />
          </IconButton>
        </>
      ) : null}
    </MuiDialogTitle>
  );
});
const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: " #0B3845",
  },
  tooltip: {
    backgroundColor: " #0B3845",
  },
}));
function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

class Test extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    result: "",
    facingMode: "user",
    legacyMode: false,
    open: false,
    value: "",
    errorScanner: false,
  };
  handleOpenError = () => {
    this.setState({
      errorScanner: true,
      open: false,
    });
  };
  handleCloseError = () => {
    this.setState({
      errorScanner: false,
    });

  };
  handleOpen = () => {
    this.setState({
      open: true,
    });
  };
  handleClose = () => {
    this.setState({
      open: false,
    });
  };
  handleScan = (data) => {
    if (data !== null) {
      this.setState({
        result: data,
      });
    }
  };
  handleError = (err) => {
    this.setState({ legacyMode: true });
  };

  choiceButton = () => {
    if (this.state.facingMode === "environment") {
      this.setState({
        facingMode: "user",
      });
    } else {
      this.setState({
        facingMode: "environment",
      });
    }
  };
  openImageDialog() {
    this.ref.qrReader1.openImageDialog();
  }
  guardarInfo = (data) => {
    if (data){
      let info=JSON.parse(data)
      if (!info.AppKey || !info.DevEui || !info.Modelo){
        this.handleOpenError()
      }else{
        this.setState({ 
          open: false
        });
        this.props.appKey(info.AppKey);
        this.props.devEUI(info.DevEui);
        this.props.modelo(info.Modelo);
      }
       
    } else {
        setTimeout(this.handleOpenError, 5000)
    }
  };

  render() {
    const previewStyle = {
      width: 379,
      zIndex: 999,
    };
    const previewStyleMobile = {
      width: "300px",
      zIndex: 999,
    };

    return (
      <div style={{ position: "relative" }}>
        <BootstrapTooltip
          PopperProps={{
            disablePortal: true,
          }}
          onClose={this.props.tooltipClose}
          open={this.props.tooltipOpen}
          disableTouchListener
          arrow
          placement="left"
          title={
            <p
              style={{
                zIndex: 999,
                fontSize: "12px",
                minWidth: 150,
                textAlign: "center",
              }}
            >
              Recuerde que puede autocompletar los datos escaneando el codigo QR
              del dispositivo con la camara web de su computadora
            </p>
          }
        >
          <div
            style={{ cursor: "pointer" }}
            onClick={this.handleOpen}
            onMouseOver={this.props.tooltipStatus}
          >
            <img
              src={qr}
              style={{ marginTop: "8px", width: "25px", height: "25px" }}
            />
          </div>
        </BootstrapTooltip>
        {this.state.open ? (
          <Dialog
            onClose={this.handleClose}
            open={this.state.open}
            style={{ width: this.props.movil ? "350px" : "100%" }}
          >
            <DialogTitle
              id="customized-dialog-title"
              onClose={this.handleClose}
              style={{ paddingBottom: "5px" }}
            >
              Escanear QR
              {!this.props.movil ? (
                <>
                  <Tooltip
                    arrow
                    title={
                      <p
                        style={{
                          zIndex: 999,
                          fontSize: "12px",
                          minWidth: 70,
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        Ayuda
                      </p>
                    }
                  >
                    <img
                      src={Informacion}
                      style={{
                        zIndex: 999,
                        marginLeft: "170px",
                        marginTop: "11px",
                        width: "25px",
                        height: "25px",
                      }}
                    />
                  </Tooltip>
                  <hr></hr>
                </>
              ) : null}
            </DialogTitle>
            <div
              style={{
                width: this.props.movil ? "370px" : "380px",
                height: this.props.movil ? "340px" : "420px",
              }}
            >
              <QrReader
                delay={this.state.delay}
                style={this.props.movil ? previewStyleMobile : previewStyle}
                onError={this.handleError}
                onScan={this.handleScan}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={this.choiceButton}
                style={{
                  height: "30px",
                  width: "50%",
                  margin: "5px",
                  color: "#FCFCFC",
                  backgroundColor: "#0B3845",
                }}
              >
                Cambiar de cámara
              </Button>
              {/* {this.state.legacyMode ? 
                        (<input type="button" value="Adjuntar QR" onClick={()=>this.openImageDialog()}/>) 
                        : 
                        ('')} */}
               <p>{this.state.result}</p>
              {this.state.result ? this.guardarInfo(this.state.result) : null}
            </div>
          </Dialog>
        ) : null}
        {this.state.errorScanner &&
          <ScannerError handleClose={this.handleCloseError}/>
        }
      </div>
    );
  }
}
export default Test;
